import * as React from 'react';
import { AppBarComponent } from '@syncfusion/ej2-react-navigations';
import { useState } from 'react';
import { MessageComponent } from '@syncfusion/ej2-react-notifications';
import { ButtonComponent } from '@syncfusion/ej2-react-buttons';

interface IUnsupportedLinkProps {
}

function UnsupportedLink(props: IUnsupportedLinkProps) {

    const [visible, setVisible] = useState<boolean>(true);
    const [cssClass, setCssClass] = useState<string>(
        'e-outline e-primary e-success msg-hidden'
    );
    
    const closed = () => {
        setCssClass('e-outline e-primary e-success');
    };
    
    const contentTemplate = () => {
        return (
            <div>
                <h1>На жаль, сталася помилка</h1>
                <p>Це посилання недійсне</p>
            </div>
        );
    };

    return (
        <React.Fragment>
            <div className="row" style={{ maxHeight: '40px', marginBottom: '20px' }}>
                <div className="col-md-12">
                    <AppBarComponent mode="Dense" colorMode="Primary">
                        <ButtonComponent 
                            //ref={denseBtn => (denseBtn = denseBtn)} 
                            aria-label='menu' 
                            cssClass='e-inherit menu' 
                            iconCss='e-icons e-menu'
                        ></ButtonComponent>
                        <span className="dense">{localStorage.getItem('appName')}</span>
                        <div className="e-appbar-spacer"></div>
                    </AppBarComponent>
                </div>
            </div>
                <div className="msg-template-section">
                    <div className="content-section">
                        <MessageComponent id="msg_template" visible={visible} content={contentTemplate} severity="Error" closed={closed} />
                    </div>
                </div>
        </React.Fragment>
    );
}
export default UnsupportedLink;